var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 6.5V11H9L12 14L15 11H12.6V6.5H11.4Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5H7.2V17.25H6L6 6.5Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 16.05H17.4V17.25H6.6V16.05Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 6.5H18V17.25H16.8V6.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b4a9a27740acde887bf974f603baeb0c.svg";
export { ForwardRef as ReactComponent };